import React, { useState } from 'react';
import { FaRegEye, FaGithub } from 'react-icons/fa';
import './portfolio.css';

const Portfolio = () => {
      // Toggle between  tabs
      const [toggleState, setToggleState] = useState(1);
    
      const toggleTab = (index) => {
          setToggleState(index);
      };
  return (
    <section className='portfolio section' id='portfolio'>
        <h2 className='section__title'> Portfolio</h2>
        <h3 className='section__subtitle'>Porjects</h3>
        <div className='box portfolio_container container'>
          {/* Tab Heading */}
          <div className='tabs'>
            <div className={
                    toggleState === 1 ? 'portfolio__button button--flex portfolio__active'
                    : 'portfolio__button button--flex' } onClick = {() => toggleTab(1)}
            >Web Apps</div>

           
          </div>

          {/* Tab Content */}
          <div className='contents'>
            <div className={toggleState === 1 ? 'portfolio__content portfolio__content-active' : 'portfolio__content'} >
              <div className='portfolio__items grid'>
                <div className='portfolio__item'>
                <a href="https://www.remaxhallmark.com/" target="_blank" rel="noreferrer">
                  <img src={require('../../assets/portfolio/portfolio1.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                  
                  <span className='portfolio__subtitle'>Re/max Hallmark</span>
                  <div class="portfolio__icons">Visit Website <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="portfolio__icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path></svg></div>
               </a>
                </div>

                <div className='portfolio__item'>
                <a href="https://homesbyheritage.ca/" target="_blank" rel="noreferrer">
                  <img src={require('../../assets/portfolio/portfolio2.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                  
                  <span className='portfolio__subtitle'>Century 21 Heritage Group</span>
                  <div class="portfolio__icons">Visit Website <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="portfolio__icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path></svg></div>
               </a>
                </div>

                <div className='portfolio__item'>
                <a href="https://remaxultimate.com/" target="_blank" rel="noreferrer">
                  <img src={require('../../assets/portfolio/portfolio3.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                 
                  <span className='portfolio__subtitle'>RE/MAX Ultimate</span>
                  <div class="portfolio__icons">Visit Website <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="portfolio__icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path></svg></div>
              </a>
                </div>


                <div className='portfolio__item'>
                <a href="https://realtor.remarketer.ca/Account/Login?returnUrl=/members/default" target="_blank" rel="noreferrer">
                  <img src={require('../../assets/portfolio/portfolio4.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                 
                  <span className='portfolio__subtitle'>REMARKETER Dashboard</span>
                  <div class="portfolio__icons">Visit Website <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="portfolio__icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path></svg></div>
              </a>
                </div>


                <div className='portfolio__item'>
                <a href="https://www.bellaleegroup.com/" target="_blank" rel="noreferrer">
                  <img src={require('../../assets/portfolio/portfolio5.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                
                  <span className='portfolio__subtitle'>Realtor Website</span>
                  <div class="portfolio__icons">Visit Website <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="portfolio__icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path></svg></div>
              </a>
                </div>


                <div className='portfolio__item'>
                  <img src={require('../../assets/portfolio/portfolio8.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                  <a href="" target="_blank" rel="noreferrer">
                  <span className='portfolio__subtitle'>Fitness/Comming Soon</span>
                  <div class="portfolio__icons">Visit Website <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" class="portfolio__icon" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"></path></svg></div>
                 </a>
                </div>

              </div>
            </div>
            <div className={toggleState === 2 ? 'portfolio__content portfolio__content-active' : 'portfolio__content'}>
            <div className='portfolio__items grid'>
                <div className='portfolio__item'>
                  <img src={require('../../assets/portfolio/portfolio6.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                  <h3 className='portfolio__title'>Portfolio Title</h3>
                  <div className='portfolio__icons'>
                   
                    <a href='/' target='_blank' rel="noreferrer"><FaRegEye className='portfolio__icon'/></a>
                  </div>
                </div>

                <div className='portfolio__item'>
                  <img src={require('../../assets/portfolio/portfolio7.jpg')} alt='Profile' title='Profile' className='portfolio__item_img'/>
                  <h3 className='portfolio__title'>Portfolio Title</h3>
                  <div className='portfolio__icons'>
                   
                    <a href='/' target='_blank' rel="noreferrer"><FaRegEye className='portfolio__icon'/></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </section>
  )
}

export default Portfolio